export const ProductsData = [
  {
    categoryName: "Ameliyathane Tekstil Grubu",
    categoryUrl: "ameliyathane-tekstil-grubu",
    products: [
      // {
      //   productName: "Ameliyat Box",
      //   productUrl: "ameliyat-box",
      // },
      {
        productName: "Ameliyathane Örtü Setleri",
        productUrl: "ameliyathane-ortu-setleri",
      },
      {
        productName: "Ameliyat Örtüsü",
        productUrl: "ameliyat-ortusu",
      },
      // {
      //   productName: "Cerrahi Onluk",
      //   productUrl: "cerrahi-onluk",
      // },
      // {
      //   productName: "Cerrahi Seti",
      //   productUrl: "cerrahi-seti",
      // },

      {
        productName: "Ameliyathane Keten Kumaşları Z Katlama",
        productUrl: "ameliyathane-keten-kumaslari-z-katlama",
      },

      {
        productName: "Ameliyathane Keten Kumaşları Rolik",
        productUrl: "ameliyathane-keten-kumaslari-rolik",
      },
      // {
      //   productName: "Doğum Seti",
      //   productUrl: "dogum-seti",
      // },
      // {
      //   productName: "Keten Kumaş",
      //   productUrl: "keten-kumas",
      // },
      // {
      //   productName: "Kısa Kollu Hasta Onluk",
      //   productUrl: "kisa-kollu-hasta-onluk",
      // },
      // {
      //   productName: "Uzun Kollu Hasta Onluk",
      //   productUrl: "uzun-kollu-hasta-onluk",
      // },
      // {
      //   productName: "Hastane Yeşil Örtü",
      //   productUrl: "hastane-yesil-ortu",
      // },
    ],
  },

  {
    categoryName: "Ameliyathane ve Hasta Önlükleri",
    categoryUrl: "ameliyathane-ve-hasta-onlukleri",
    products: [
      {
        productName: "Ameliyat Box",
        productUrl: "ameliyat-box",
      },

      {
        productName: "Cerrahi Önlük",
        productUrl: "cerrahi-onluk",
      },

      {
        productName: "Kısa Kollu Hasta Önlük",
        productUrl: "kisa-kollu-hasta-onluk",
      },

      {
        productName: "Uzun Kollu Hasta Önlük",
        productUrl: "uzun-kollu-hasta-onluk",
      },
      {
        productName: "Ameliyathane Formaları",
        productUrl: "ameliyathane-onlukleri",
      },
    ],
  },

  {
    categoryName: "Hastane Tekstil Grubu",
    categoryUrl: "hastane-tekstil-grubu",
    products: [
      {
        productName: "Nevresim Takımı",
        productUrl: "hastane-nevresim",
      },
      {
        productName: "Çarşaf",
        productUrl: "carsaf",
      },

      {
        productName: "Yastık Kılıfı",
        productUrl: "yastik-kilifi",
      },

      {
        productName: "Çocuk Nevresim",
        productUrl: "cocuk-nevresim",
      },
      {
        productName: "Battaniye",
        productUrl: "battaniye",
      },
      {
        productName: "Hastane Havlusu",
        productUrl: "bebek",
      },


      {
        productName: "Bebek Havlusu",
        productUrl: "hastane-havlu",
      },

      {
        productName: "Pike",
        productUrl: "hastane-pikesi",
      },

      {
        productName: "Kefen Bezi",
        productUrl: "kaput-bezi",
      },

      {
        productName: "Perde",
        productUrl: "perde",
      },

      {
        productName: "Yastık",
        productUrl: "yastik",
      },

      {
        productName: "Yastık Alezi",
        productUrl: "yastik-koruyucu",
      },

      {
        productName: "Yatak Alezi",
        productUrl: "yatak-koruyucu",
      },
      {
        productName: "Sedye Alezi",
        productUrl: "sedye",
      },
    ],
  },

  {
    categoryName: "Enjektörler, İğne Uçları Ve Serum Setleri",
    categoryUrl: "enjektor-igne-uclari-ve-serum-setleri",
    products: [
      {
        productName: "3P Enjektörler",
        productUrl: "3p-enjektorler",
      },
      {
        productName: "50ml Enjektörler",
        productUrl: "50ml-enjektorler",
      },
      {
        productName: "Aşı Enjektörleri",
        productUrl: "asi-enjektorleri",
      },

      {
        productName: "Dental Enjektörler",
        productUrl: "dental-enjektorler",
      },
      {
        productName: "Hipodermil İğne Uçları",
        productUrl: "hipodermil-igne-uclari",
      },
      {
        productName: "İnsülin Enjektörleri",
        productUrl: "insulin-enjektorleri",
      },

      {
        productName: "Kan Gazi Enjektörleri",
        productUrl: "kan-gazi-enjektorleri",
      },

      {
        productName: "Luer Lock Enjektörler",
        productUrl: "luer-lock-enjektorler",
      },


      {
        productName: "Serum Setleri",
        productUrl: "serum-setleri",
      },
      {
        productName: "Veteriner Enjektörleri",
        productUrl: "veteriner-enjektorleri",
      },






    ],
  },
  {
    categoryName: "Medikal Sarf Grubu",
    categoryUrl: "medikal-sarf-grubu",
    products: [
      {
        productName: "Bebek Bezi",
        productUrl: "bebek-bezi",
      },
      {
        productName: "Ekru Bandaj",
        productUrl: "ekru-bandaj",
      },
      {
        productName: "Elastik Bandaj",
        productUrl: "elastik-bandaj",
      },
      {
        productName: "Elastik Sargı Bezi",
        productUrl: "elastik-sargi-bezi",
      },
      {
        productName: "Gaz Kompres",
        productUrl: "gaz-kompres",
      },
      {
        productName: "Hasta Yetişkin Bezi",
        productUrl: "hasta-yetiskin-bezi",
      },
      {
        productName: "Hidrofil Sargı Bezi",
        productUrl: "hidrofil-sargi-bezi",
      },
      {
        productName: "İdeal Bandaj",
        productUrl: "ideal-bandaj",
      },
      {
        productName: "Krep Sargı Bezi",
        productUrl: "krep-sargi-bezi",
      },
      {
        productName: "Pamuklu Ped",
        productUrl: "pamuklu-ped",
      },
      {
        productName: "Pamuklu Sargı Bezi",
        productUrl: "pamuklu-sargi-bezi",
      },
      {
        productName: "Renkli İdeal Bandaj",
        productUrl: "renkli-ideal-bandaj",
      },
      {
        productName: "Ten Rengi İdeal Bandaj",
        productUrl: "ten-rengi-ideal-bandaj",
      },
      {
        productName: "Universal Bandaj",
        productUrl: "universal-bandaj",
      },
      {
        productName: "Hasta Bileklik",
        productUrl: "hasta-bileklik",
      },
    ],
  },

  {
    categoryName: "Muayene Eldivenleri",
    categoryUrl: "muayene-eldivenleri",
    products: [
        // {
        //     productName: "Cerrahi Steril Pudralı Eldivenler",
        //     productUrl: "cerrahi-steril-pudrali-eldivenler",
        //   },
        //   {
        //     productName: "Cerrahi Steril Pudrasız Eldivenler",
        //     productUrl: "cerrahi-steril-pudrasiz-eldivenler",
        //   },
        //   {
        //     productName: "Muayene ve Cerrahi Eldivenler",
        //     productUrl: "muayene-ve-cerrahi-eldivenler",
        //   },
          {
            productName: "Lateks Eldivenler",
            productUrl: "latex-eldivenler",
          },
          {
            productName: "Vinil Eldivenler",
            productUrl: "vinil-eldivenler",
          },
          {
            productName: "Nitril Eldivenler",
            productUrl: "nitril-eldivenler",
          },
          {
            productName: "Kalın ve Uzun Manset Eldivenler",
            productUrl: "kalin-ve-uzun-manset-eldivenler",
          },
    ],
  },

  {
    categoryName: "Temizlik Ekipmanları",
    categoryUrl: "temizlik-urunleri",
    products: [
      {
        productName: "Atık Toplama Arabaları",
        productUrl: "atik-toplama-arabalari",
        productImageData: [
          { name: '', image: '0' },
          { name: '', image: '1' },
          { name: '', image: '2' },
          { name: '', image: '3' },
          { name: '', image: '4' },
          { name: '', image: '5' },
          { name: '', image: '6' },
          { name: '', image: '7' },
          { name: '', image: '8' },
          { name: '', image: '9' },
          { name: '', image: '10' },
          { name: '', image: '11' },
          { name: '', image: '12' },
          { name: '', image: '13' },
          { name: '', image: '14' }
        ]
      },
      {
        productName: "Çamaşır Toplama Arabaları",
        productUrl: "camasir-toplama-arabalari",
        productImageData: [
          { name: '', image: '0' },
          { name: '', image: '1' },
          { name: '', image: '2' },
          { name: '', image: '3' },
          { name: '', image: '4' },
          { name: '', image: '5' }
        ]
      },
      {
        productName: "Hastane Arabaları",
        productUrl: "hastane-arabalari",
        productImageData: [
          { name: '', image: '0' },
          { name: '', image: '1' },
          { name: '', image: '2' },
          { name: '', image: '3' },
          { name: '', image: '4' },
          { name: '', image: '5' },
          { name: '', image: '6' },
          { name: '', image: '7' },
          { name: '', image: '8' },
          { name: '', image: '9' },
          { name: '', image: '10' },
          { name: '', image: '11' },
          { name: '', image: '12' },
          { name: '', image: '13' },
          { name: '', image: '14' },
          { name: '', image: '15' },
          { name: '', image: '16' },
          { name: '', image: '17' },
          { name: '', image: '18' },
          { name: '', image: '19' },
          { name: '', image: '20' },
          { name: '', image: '21' },
          { name: '', image: '22' },
          { name: '', image: '23' },
          { name: '', image: '24' },
          { name: '', image: '25' },
          { name: '', image: '26' },
          { name: '', image: '27' },
          { name: '', image: '28' },
          { name: '', image: '29' }
        ]
      },
      {
        productName: "Kat Arabaları",
        productUrl: "kat-arabalari",
        productImageData: [
          { name: '', image: '0' },
          { name: '', image: '1' },
          { name: '', image: '2' },
          { name: '', image: '3' },
          { name: '', image: '4' },
          { name: '', image: '5' },
          { name: '', image: '6' },
          { name: '', image: '7' },
          { name: '', image: '8' },
          { name: '', image: '9' },
          { name: '', image: '10' },
          { name: '', image: '11' },
          { name: '', image: '12' },
          { name: '', image: '13' },
          { name: '', image: '14' },
          { name: '', image: '15' },
          { name: '', image: '16' },
          { name: '', image: '17' },
          { name: '', image: '18' },
          { name: '', image: '19' },
          { name: '', image: '20' },
          { name: '', image: '21' },
          { name: '', image: '22' },
          { name: '', image: '23' },
          { name: '', image: '24' },
          { name: '', image: '25' },
          { name: '', image: '26' },
          { name: '', image: '27' },
          { name: '', image: '28' },
          { name: '', image: '29' },
          { name: '', image: '30' },
          { name: '', image: '31' },
          { name: '', image: '32' },
          { name: '', image: '33' },
          { name: '', image: '34' },
          { name: '', image: '35' },
          { name: '', image: '36' },
          { name: '', image: '37' },
          { name: '', image: '38' },
          { name: '', image: '39' },
          { name: '', image: '40' },
          { name: '', image: '41' },
          { name: '', image: '42' },
          { name: '', image: '43' },
          { name: '', image: '44' },
          { name: '', image: '45' },
          { name: '', image: '46' },
          { name: '', image: '47' },
          { name: '', image: '48' },
          { name: '', image: '49' },
          { name: '', image: '50' },
          { name: '', image: '51' },
          { name: '', image: '52' },
          { name: '', image: '53' },
          { name: '', image: '54' },
          { name: '', image: '55' },
          { name: '', image: '56' },
          { name: '', image: '57' },
          { name: '', image: '58' },
          { name: '', image: '59' },
          { name: '', image: '60' },
          { name: '', image: '61' },
          { name: '', image: '62' },
          { name: '', image: '63' },
          { name: '', image: '64' },
          { name: '', image: '65' },
          { name: '', image: '66' },
          { name: '', image: '67' },
          { name: '', image: '68' }
        ]
      },
      {
        productName: "Servis Arabaları",
        productUrl: "servis-arabalari",
        productImageData: [
          { name: '', image: '0' },
          { name: '', image: '1' },
          { name: '', image: '2' },
          { name: '', image: '3' },
          { name: '', image: '4' },
          { name: '', image: '5' },
          { name: '', image: '6' },
          { name: '', image: '7' },
          { name: '', image: '8' },
          { name: '', image: '9' },
          { name: '', image: '10' },
          { name: '', image: '11' },
          { name: '', image: '12' },
          { name: '', image: '13' },
          { name: '', image: '14' },
          { name: '', image: '15' },
          { name: '', image: '16' },
          { name: '', image: '17' },
          { name: '', image: '18' },
          { name: '', image: '19' },
          { name: '', image: '20' },
          { name: '', image: '21' },
          { name: '', image: '22' },
          { name: '', image: '23' },
          { name: '', image: '24' },
          { name: '', image: '25' },
          { name: '', image: '26' },
          { name: '', image: '27' },
          { name: '', image: '28' },
          { name: '', image: '29' },
          { name: '', image: '30' },
          { name: '', image: '31' },
          { name: '', image: '32' },
          { name: '', image: '33' },
          { name: '', image: '34' },
          { name: '', image: '35' },
          { name: '', image: '36' },
          { name: '', image: '37' },
          { name: '', image: '38' },
          { name: '', image: '39' },
          { name: '', image: '40' },
          { name: '', image: '41' },
          { name: '', image: '42' },
          { name: '', image: '43' },
          { name: '', image: '44' },
          { name: '', image: '45' },
          { name: '', image: '46' }
        ]
      },
      {
        productName: "Temizlik Arabaları",
        productUrl: "temizlik-arabalari",
        productImageData: [
          { name: '', image: '0' },
          { name: '', image: '1' },
          { name: '', image: '2' },
          { name: '', image: '3' },
          { name: '', image: '4' },
          { name: '', image: '5' },
          { name: '', image: '6' },
          { name: '', image: '7' },
          { name: '', image: '8' },
          { name: '', image: '9' },
          { name: '', image: '10' },
          { name: '', image: '11' },
          { name: '', image: '12' },
          { name: '', image: '13' },
          { name: '', image: '14' },
          { name: '', image: '15' },
          { name: '', image: '16' },
          { name: '', image: '17' },
          { name: '', image: '18' },
          { name: '', image: '19' },
          { name: '', image: '20' },
          { name: '', image: '21' },
          { name: '', image: '22' },
          { name: '', image: '23' },
          { name: '', image: '24' },
          { name: '', image: '25' },
          { name: '', image: '26' },
          { name: '', image: '27' },
          { name: '', image: '28' },
          { name: '', image: '29' },
          { name: '', image: '30' },
          { name: '', image: '31' },
          { name: '', image: '32' },
          { name: '', image: '33' },
          { name: '', image: '34' },
          { name: '', image: '35' },
          { name: '', image: '36' },
          { name: '', image: '37' },
          { name: '', image: '38' },
          { name: '', image: '39' },
          { name: '', image: '40' },
          { name: '', image: '41' },
          { name: '', image: '42' },
          { name: '', image: '43' },
          { name: '', image: '44' },
          { name: '', image: '45' },
          { name: '', image: '46' },
          { name: '', image: '47' },
          { name: '', image: '48' },
          { name: '', image: '49' },
          { name: '', image: '50' },
          { name: '', image: '51' },
          { name: '', image: '52' },
          { name: '', image: '53' },
          { name: '', image: '54' },
          { name: '', image: '55' },
          { name: '', image: '56' },
          { name: '', image: '57' },
          { name: '', image: '58' },
          { name: '', image: '59' },
          { name: '', image: '60' },
          { name: '', image: '61' },
          { name: '', image: '62' },
          { name: '', image: '63' },
          { name: '', image: '64' },
          { name: '', image: '65' },
          { name: '', image: '66' },
          { name: '', image: '67' },
          { name: '', image: '68' },
          { name: '', image: '69' },
          { name: '', image: '70' },
          { name: '', image: '71' },
          { name: '', image: '72' },
          { name: '', image: '73' },
          { name: '', image: '74' },
          { name: '', image: '75' },
          { name: '', image: '76' },
          { name: '', image: '77' },
          { name: '', image: '78' },
          { name: '', image: '79' },
          { name: '', image: '80' },
          { name: '', image: '81' },
          { name: '', image: '82' },
          { name: '', image: '83' },
          { name: '', image: '84' },
          { name: '', image: '85' },
          { name: '', image: '86' },
          { name: '', image: '87' },
          { name: '', image: '88' },
          { name: '', image: '89' },
          { name: '', image: '90' },
          { name: '', image: '91' },
          { name: '', image: '92' },
          { name: '', image: '93' },
          { name: '', image: '94' },
          { name: '', image: '95' },
          { name: '', image: '96' },
          { name: '', image: '97' },
          { name: '', image: '98' },
          { name: '', image: '99' },
          { name: '', image: '100' },
          { name: '', image: '101' },
          { name: '', image: '102' }
        ]
      },
      {
        productName: "Temizlik Setleri",
        productUrl: "temizlik-setleri",
        productImageData: [
          { name: '', image: '0' },
          { name: '', image: '1' },
          { name: '', image: '2' },
          { name: '', image: '3' },
          { name: '', image: '4' },
          { name: '', image: '5' },
          { name: '', image: '6' },
          { name: '', image: '7' },
          { name: '', image: '8' },
          { name: '', image: '9' },
          { name: '', image: '10' },
          { name: '', image: '11' },
          { name: '', image: '12' },
          { name: '', image: '13' },
          { name: '', image: '14' },
          { name: '', image: '15' },
          { name: '', image: '16' },
          { name: '', image: '17' },
          { name: '', image: '18' },
          { name: '', image: '19' },
          { name: '', image: '20' },
          { name: '', image: '21' },
          { name: '', image: '22' },
          { name: '', image: '23' }
        ]
      },
      {
        productName: "Yük Taşıma Arabaları",
        productUrl: "yuk-tasima-arabalari",
        productImageData: [
          { name: '', image: '0' },
          { name: '', image: '1' },
          { name: '', image: '2' },
          { name: '', image: '3' }
        ]
      },
      {
        productName: "Zemin Temizlik Makineleri",
        productUrl: "zemin-temizlik-makineleri",
        productImageData: [
          { name: 'Zemin Bakım Halı Yıkama & Cilalama Makinesi', image: '0' },
          { name: 'Surface Care & Polishing Machine', image: '1' },
          { name: 'Binicili Akülü Zemin Süpürücüsü', image: '2' },
          { name: 'Arkadan İtmeli Vakumlu Manuel Süpürücü', image: '3' },
          { name: 'Binicili Akülü Zemin Süpürücüsü', image: '4' },
          { name: 'Halı Yıkama Makinesi', image: '5' },
          { name: 'Halı Kurutma Makinesi', image: '6' },
          { name: 'Nano Dezenfektan Makinesi', image: '7' },
          { name: 'OTEL TİPİ SESSİZ PROFESYONEL ELEKTRİKLİ SÜPÜRGE', image: '8' },
          { name: 'Arkadan İtmeli Elektrikli Zemin Temizleme Makinesi', image: '9' },
          { name: 'Arkadan İtmeli Akülü Zemin Temizleme Makinesi', image: '10' },
          { name: 'Kompakt Akülü Zemin Temizleme Makinesi', image: '11' },
          { name: 'Arkadan İtmeli Akülü Zemin Temizleme Makinesi', image: '12' },
          { name: 'Eletrikli Yürüyen Merdiven Temizleme Makinesi', image: '13' },
          { name: 'Arkadan İtmeli Elektrikli Zemin Temizleme Makinesi', image: '14' },
          { name: 'Binicili Akülü Zemin Temizleme Makinesi', image: '15' },
          { name: 'Binicili Akülü Zemin Temizleme Makinesi', image: '16' },
          { name: 'Binicili Akülü Zemin Temizleme Makinesi', image: '17' },
          { name: 'Binicili Akülü Zemin Temizleme Makinesi', image: '18' },
          { name: 'Binicili Akülü Kombine Zemin Temizleme Makinesi', image: '19' }
        ]
      }
    ],
  },
  





  {
    categoryName: "Kağıt Ürünleri",
    categoryUrl: "kagit-urunleri",
    products: [
      {
        productName: "Ev Tipi Kağıt Havlu",
        productUrl: "ev-tipi-kagit-havlu",
      },
      {
        productName: "Ev Tipi Tuvalet Kağıdı",
        productUrl: "ev-tipi-tuvalet-kagidi",
      },
      {
        productName: "Hareketli Havlular",
        productUrl: "hareketli-havlular",
      },
      {
        productName: "İçten Çekmeli Kağıt Havlu",
        productUrl: "icten-cekmeli-kagit-havlu",
      },
      {
        productName: "İçten Çekmeli Tuvalet Kağıdı",
        productUrl: "icten-cekmeli-tuvalet-kagidi",
      },
      {
        productName: "Jumbo Tuvalet Kağıdı",
        productUrl: "jumbo-tuvalet-kagidi",
      },
      {
        productName: "Kağıt El Havlusu Fotoselli",
        productUrl: "kagit-el-havlusu-fotoselli",
      },
      {
        productName: "Servis Peçete",
        productUrl: "servis-pecete",
      },
      {
        productName: "Z Katlamalı Kağıt Havlu",
        productUrl: "z-katlamali-kagit-havlu",
      },
    ],
  },
  {
    categoryName: "Atık yönetimi Grubu",
    categoryUrl: "atik-yonetimi-ve-diger-sarf-malzemeleri",
    products: [
      {
        productName: "Atık Kovaları",
        productUrl: "atik-kovalari",
      },
      {
        productName: "Çöp Kovaları",
        productUrl: "cop-kovalari",
      },
      // {
      //   productName: "Kat Temizlik Arabaları",
      //   productUrl: "kat-temizlik-arabalari",
      // },
      {
        productName: "Mikrofiber Temizlik Bezleri",
        productUrl: "mikrofiber-temizlik-bezleri",
      },
      {
        productName: "Temizlik Setleri",
        productUrl: "temizlik-setleri",
      },
    ],
  },
];
